import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Home from '@/pages/Home';
import ProductDetail from '@/pages/ProductDetail';
import Browse from '@/pages/Browse';
import ContactPage from '@/pages/ContactPage';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminTraffic from '@/pages/AdminTraffic';
import AdminWealthPlanner from '@/pages/AdminWealthPlanner';
import AdminSoldCleanup from '@/pages/AdminSoldCleanup';
import LandingPage from '@/pages/LandingPage';
import { LANDING_PAGES } from '@/pages/landing-content';
import ProtectedRoute from '@/components/ProtectedRoute';
import ScrollToTop from '@/components/ScrollToTop';
import useTracker from '@/hooks/useTracker';
import { AuthProvider } from '@/contexts/AuthContext';

function TrackerRunner() {
  useTracker();
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <TrackerRunner />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/category/:key" element={<Browse mode="category" />} />
            <Route path="/search" element={<Browse mode="search" />} />
            <Route path="/contact" element={<ContactPage />} />
            {/* Category alias URLs — permanent redirect to canonical /category/{key}.
                Static hosting emits meta-refresh HTML via generate-seo-html.js;
                these <Navigate> handlers cover in-app client-side navigations. */}
            <Route path="/sarees" element={<Navigate to="/category/sarees" replace />} />
            <Route path="/lehengas" element={<Navigate to="/category/lehengas" replace />} />
            <Route path="/bridal-wear" element={<Navigate to="/category/bridal" replace />} />
            <Route path="/kurti-sets" element={<Navigate to="/category/family" replace />} />
            <Route path="/party-wear" element={<Navigate to="/category/gowns" replace />} />
            <Route path="/shararas" element={<Navigate to="/category/sharara-suits" replace />} />
            <Route path="/gowns" element={<Navigate to="/category/gowns" replace />} />
            <Route path="/men" element={<Navigate to="/category/mens" replace />} />
            <Route path="/kids" element={<Navigate to="/category/kids" replace />} />
            {/* Kept as its own unique landing page (no fixed category) */}
            <Route path="/plus-size" element={<Browse mode="category" fixedKey="plus-size" />} />
            {/* Phase-2 SEO landing pages */}
            {Object.values(LANDING_PAGES).map((cfg) => (
              <Route key={cfg.slug} path={`/${cfg.slug}`} element={<LandingPage {...cfg} />} />
            ))}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/traffic"
              element={
                <ProtectedRoute>
                  <AdminTraffic />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/wealth-planner"
              element={
                <ProtectedRoute>
                  <AdminWealthPlanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/sold-cleanup"
              element={
                <ProtectedRoute>
                  <AdminSoldCleanup />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="bottom-left" richColors closeButton />
    </div>
  );
}

export default App;
